import React from "react";
import { Space, Typography } from "antd";
import ItemizedJobCard from "components/jobs/ItemizedJobCard";
import DateRangeStart from "components/jobs/DateRangeStart";
import useApiKeyCheck from "hooks/useApiKeyCheck";
import { apiKeyNotice, apiKeyTags } from "pages/jobs/apiKeyStatus";
import { BatchJobItem } from "reducers/types";
import { rangeLabel } from "pages/jobs/rangeLabel";

interface Props {
  /** Whether the server has POLYGON_API_KEY loaded; undefined while unknown. */
  keyLoaded?: boolean;
}


const polygonDetails = (item: BatchJobItem) => {
  if (item.status === "NO_DATA") {
    return <Typography.Text type="secondary">no data (weekend/holiday)</Typography.Text>;
  }
  const d = item.details;
  if (!d) {
    return null;
  }
  return (
    <Typography.Text type="secondary">
      written {d.written} / fetched {d.fetched}
      {d.reverse > 0 ? ` · ${d.reverse} reverse` : ""}
      {d.unmapped > 0 ? ` · ${d.unmapped} unmapped` : ""}
      {d.carried > 0 ? ` · ${d.carried} carried` : ""}
      {d.documentCreated > 0 ? ` · ${d.documentCreated} created` : ""}
      {d.kept > 0 ? ` · ${d.kept} kept` : ""}
      {d.collisionIgnored > 0 ? ` · ${d.collisionIgnored} collision ignored` : ""}
      {d.ambiguousTicker > 0 ? ` · ${d.ambiguousTicker} ambiguous ticker` : ""}
    </Typography.Text>
  );
};

// Polygon closing prices of Nasdaq stocks for a date range, processed date by date on the server (job type polygon-history).
const PolygonHistoryCard: React.FC<Props> = ({ keyLoaded }) => {
  const check = useApiKeyCheck("polygon", keyLoaded === true);
  return (
    <ItemizedJobCard
      title={
        <Space>
          Nasdaq (Polygon) Parity History
          {apiKeyTags(keyLoaded, check)}
        </Space>
      }
      basePath="/admin/resources/update/polygon/history"
      start={({ start }) =>
        apiKeyNotice("POLYGON_API_KEY", "Polygon", keyLoaded, check) || <DateRangeStart onStart={start} onlyPast withOverride />
      }
      renderLabel={rangeLabel}
      renderDetails={polygonDetails}
    />
  );
};

export default PolygonHistoryCard;
